// eslint-disable-next-line no-use-before-define
import React, { Suspense, useState } from 'react';
import { useQuery } from 'react-query';

import { Badge, Card, Space } from 'antd';

import  './index.less';
import DF from 'DisplayFramework';

import MyNotificationsTable from 'pages/Landing/components/MyNotificationsTable';

import HeaderDropdown from 'components/HeaderDropdown';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { GetListProcTaskNotif } from 'services/workflow';
import INotification from 'icons/INotification';

const NotifLinks = () => {
  const [countNotif, setCountNotif] = useState(0);

  const { data } = useQuery(
    'GetListProcTaskNotif',
    () =>
      GetListProcTaskNotif().then((res) => {
        setCountNotif(res?.list?.length);
        return res.list;
      }),
    { refetchOnMount: true, refetchInterval: 60000 }
  );

  const menu = (
    <Suspense fallback="Loading" >
      <Card style={{ width: '800px' }}>
        <MyNotificationsTable
          height={500}
          title={<GetLabel label="notifications" />}
          isFromLink
          checkTable={data}
        />
      </Card>
    </Suspense>
  );

  return (
    <DF.Provider pagcode="welcome">
      <HeaderDropdown overlay={menu} zIndex={7}>
        <span className={`action`}>
          <Space size={24}>
            {/* <INotification color="#eb2f96" /> */}
            <INotification color="black" />
            <Badge count={countNotif} style={{ backgroundColor: 'red' }}>
              <GetLabel label="notifications" Inspectstyle={{marginBottom:"25px"}}/>
            </Badge>
          </Space>
        </span>
      </HeaderDropdown>
    </DF.Provider>
  );
};

export default NotifLinks;
